class IvsVideoPlayer {
  constructor() {
    this.player = null
    this.$modal = $('#ivs-video-modal')
    this.$container = $('#ivs-player-container')
  }

  init() {
    this.initEvents()
  }

  initEvents() {
    // Click su thumbnail video
    $(document).on('click', '[data-ivs-video]', (e) => {
      e.preventDefault()
      const $target = $(e.currentTarget)
      const videoUrl = $target.data('ivs-video')
      const videoTitle = $target.data('ivs-title') || ''
      
      this.openVideo(videoUrl, videoTitle)
    })

    // Cleanup quando si chiude il modal
    this.$modal.on('hidden.bs.modal', () => {
      this.destroyPlayer()
    })
  }

  openVideo(url, title) {
    this.$modal.modal('show')
    
    // Aspetta che il modal sia visibile prima di creare il player
    this.$modal.one('shown.bs.modal', () => {
      this.createPlayer(url)
    })
  }

  createPlayer(url) {
    if (!window.IVSPlayer || !window.IVSPlayer.isPlayerSupported) {
      console.error('IVS Player not supported')
      return
    }

    // Distruggi player esistente
    this.destroyPlayer()

    // Crea nuovo player
    const videoElement = document.getElementById('ivs-video-element')
    this.player = window.IVSPlayer.create()
    this.player.attachHTMLVideoElement(videoElement)
    this.player.load(url)
    this.player.play()
  }

  destroyPlayer() {
    if (this.player) {
      this.player.pause()
      this.player.delete()
      this.player = null
    }
  }
}

export default IvsVideoPlayer
